export type TBreakpoints = "xs" | "sm" | "md" | "lg" | "xl";

export const baseBreakpoints: Record<TBreakpoints, number> = {
	xs: 320,
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
};
